import axios from 'axios'

/**
 * Global axios response interceptor for the trial lockout. When any request
 * comes back 403 with code TRIAL_EXPIRED, route the user to the conversion
 * screen (the one place an expired trial can still act). Installed once at app
 * startup so it covers both raw-axios calls and service instances built from
 * the default axios.
 *
 * A hard redirect is used deliberately: it unmounts any in-flight screen that
 * would otherwise keep firing blocked requests. Guarded so it never loops on
 * the conversion route itself.
 */
let installed = false

const CONVERT_PATH = '/convert'
const EXEMPT_PREFIXES = [CONVERT_PATH, '/magic', '/login']

const setupTrialInterceptor = () => {
	if (installed) return
	installed = true

	axios.interceptors.response.use(
		response => response,
		error => {
			const code = error?.response?.data?.code
			if (code === 'TRIAL_EXPIRED') {
				const path = window.location.pathname
				const onExemptRoute = EXEMPT_PREFIXES.some(p => path === p || path.startsWith(`${p}/`))
				if (!onExemptRoute) {
					window.location.assign(CONVERT_PATH)
				}
			}
			return Promise.reject(error)
		},
	)
}

export default setupTrialInterceptor
